import React from "react";
import { Plus } from "lucide-react";

import Button from "../../../../components/buttons/Button";
import { EllipsisMenu } from "../../../../components/menu/ellipsis/EllipsisMenu";

import ViewContainer from "../../../../components/layout/view/ViewContainer";
import ViewHeader from "../../../../components/layout/view/ViewHeader";

import ContentPanel from "../../../../components/layout/content/ContentPanel";
import ContentItem from "../../../../components/layout/content/ContentItem";

import Heading from "../../../../components/typography/Heading";
import Text from "../../../../components/typography/Text";

import { formatPeriod } from "../utils/talentUtils";

import "./TalentExperiencesView.css";

export default function TalentExperiencesView({
  experiences = [],
  onAdd,
  onEdit,
  onRemove,
  busy = false,
  readOnly = false,
}) {
  const experienceList = Array.isArray(experiences) ? experiences : [];

  return (
    <ViewContainer>
      <ViewHeader
        title="Experience"
        description="My sporting background, teams and career journey."
        actions={
          !readOnly && (
            <Button
              value="Add Experience"
              icon={<Plus size={16} />}
              variant="primary-outlined"
              disabled={busy}
              onClick={onAdd}
            />
          )
        }
      />

      <ContentPanel>
        {!experienceList.length ? (
          <Text as="p" tone="secondary" size="sm">
            No sporting experience added yet.
          </Text>
        ) : (
          <div className="user-talent__entries">
            {experienceList.map((item) => {
              const details = [item.organisation, item.sport, item.position]
                .filter(Boolean)
                .join(" · ");

              const period = formatPeriod(
                item.startDate,
                item.endDate,
                Boolean(item.isCurrent),
              );

              return (
                <ContentItem
                  key={item.experienceId}
                  actions={
                    !readOnly && (
                      <EllipsisMenu
                        ariaLabel={`${item.title} options`}
                        position="right"
                        disabled={busy}
                        options={[
                          {
                            id: "edit",
                            label: "Edit Experience",
                            action: () => onEdit?.(item),
                          },
                          {
                            id: "delete",
                            label: "Delete Experience",
                            className: "is-danger",
                            action: () => onRemove?.(item),
                          },
                        ]}
                      />
                    )
                  }
                >
                  <Heading as="h3" size="sm">
                    {item.title}
                  </Heading>

                  {details && (
                    <Text as="p" tone="secondary" size="sm">
                      {details}
                    </Text>
                  )}

                  {period && (
                    <Text as="p" tone="secondary" size="sm">
                      {period}
                    </Text>
                  )}

                  {item.description && (
                    <Text as="p" className="user-talent__body">
                      {item.description}
                    </Text>
                  )}
                </ContentItem>
              );
            })}
          </div>
        )}
      </ContentPanel>
    </ViewContainer>
  );
}
